import React from 'react'
import { Container } from 'reactstrap'
import { Link } from 'react-router-dom'
import './footer.css'
import brandMark from '../../assets/brand/gadget-groove-mark.png'

const Footer = () => (
  <footer className='footer'>
    <Container>
      <div className='footer__cta'>
        <div><span>Need a second opinion?</span><h2>Let’s find the right tech.</h2></div>
        <a href='mailto:info@gadgetGroove.com'>Talk to an expert <i className='ri-arrow-right-line'></i></a>
      </div>

      <div className='footer__grid'>
        <div className='footer__brand'>
          <Link to='/home' className='logo logo--footer'><span className='logo__mark'><img src={brandMark} alt='' width='38' height='38' loading='lazy' decoding='async' /></span><span className='logo__word'>Gadget<span>Groove</span></span></Link>
          <p>Thoughtfully sourced gadgets, clear pricing and real support—from our store in Sukkur to your door.</p>
        </div>
        <div className='footer__links'><h4>Shop</h4><Link to='/shop'>All products</Link><Link to='/shop'>Phones</Link><Link to='/shop'>Computers</Link><Link to='/shop'>Gaming</Link></div>
        <div className='footer__links'><h4>Company</h4><Link to='/about'>About us</Link><Link to='/about'>Returns</Link><Link to='/login'>Your account</Link><Link to='/cart'>Your cart</Link></div>
        <div className='footer__links footer__contact'><h4>Visit or contact</h4><p>B:13, Akhuwat Nagar Society<br />Sukkur, Pakistan</p><a href='mailto:info@gadgetGroove.com'>info@gadgetGroove.com</a></div>
      </div>

      <div className='footer__bottom'><p>© {new Date().getFullYear()} Gadget Groove. All rights reserved.</p><div><span>Secure checkout</span><span>PKR pricing</span><span>Pakistan delivery</span><a href='https://commons.wikimedia.org/wiki/File:Playstation_5.jpg' target='_blank' rel='noopener noreferrer'>PS5 photo: Ryan Bennett · CC BY-SA 4.0</a></div></div>
    </Container>
  </footer>
)

export default Footer
